module.exports = __webpack_public_path__ + "img/pillar_of_globe_lightning_small.90b229b1.png";